import Loading from "@fragments/Loading.fragment";
import Header from "./fragments/Header.fragment";
import Content from "./fragments/Content.fragment";
import withAuth from "@auth/withAuth";
import { useGetAllProcess } from "@services/process/hooks";

const ProcessesList: React.FC = () => {
  const { data, isLoading, isFetching, isFetched, refetch } = useGetAllProcess();

  const handleReload = (): void => 
    void refetch();

  return (
    <>
      <Header />
      <Loading show={isLoading || isFetching} />
      <Content show={isFetched} data={data} reload={handleReload} />
    </>
  );
}

export default withAuth(ProcessesList);